/**
 * Keeps the product gallery in sync with the selected variant.
 *
 * The gallery itself is scoped server side in snippets/product.liquid: once a
 * variant is selected it renders that variant's own images (its assigned media
 * plus the images listed in its custom.variant_gallery metafield) followed by
 * the generic, unassigned product media. product-info already re-fetches the
 * section markup on every variant change but only swaps the active slide, so we
 * swap in the freshly rendered gallery here.
 *
 * Every gallery carries a data-gallery-signature listing the media it holds, so
 * a change that only moves the active slide within the same gallery — picking
 * another size in the same colour, say — is left for product-info to handle.
 */
(() => {
  const PRODUCT_INFO = "product-info";
  const GALLERY = "product-images";
  const MEDIA_LIST = "[data-product-media-list]";

  const replaceGallery = (productInfo, fetchedDocument) => {
    const currentGallery = productInfo.querySelector(GALLERY);
    const updatedGallery = fetchedDocument
      .querySelector(PRODUCT_INFO)
      ?.querySelector(GALLERY);

    if (!currentGallery || !updatedGallery) return;
    if (
      currentGallery.dataset.gallerySignature ===
      updatedGallery.dataset.gallerySignature
    ) {
      return;
    }

    // Replacing the whole element lets product-images, product-thumbs and
    // zoom-images tear down and re-initialise against the new set of slides.
    currentGallery.replaceWith(updatedGallery);

    // product-info caches both of these when it is constructed, so point them
    // back at the gallery that is now in the document.
    productInfo.productImages = updatedGallery;
    productInfo.productMediaList = updatedGallery.querySelector(MEDIA_LIST);
  };

  if (typeof window.subscribe !== "function") return;

  const variantChange = window.theme?.PUB_SUB_EVENTS?.variantChange;
  if (!variantChange) return;

  window.subscribe(variantChange, ({ data }) => {
    if (!data?.html) return;

    // sectionId is a getter over the section data attributes, so this is a scan
    // rather than a selector lookup.
    const productInfo = [...document.querySelectorAll(PRODUCT_INFO)].find(
      (element) => element.sectionId === data.sectionId,
    );
    if (!productInfo) return;

    replaceGallery(productInfo, data.html);
  });
})();
